import { actions } from './actions';

export const temple = {
  state: {
    temples: {},
    temple: {
      title: '廟宇文章載入中...'
    },
  },
  getters: {
    temples(state) {
      return state.temples;
    },
    temple(state) {
      return state.temple;
    },
  },
  mutations: {
    setTemples(state, payload) {
      state.temples = payload;
    },
    setTemple(state, payload) {
      state.temple = payload;
    },
    // 收合段落
    toggleTempleGuide(state, guideIndex) {
      state.temple.temple_guides[guideIndex].ariaExpanded = !state.temple.temple_guides[guideIndex].ariaExpanded;
    }
  },
  actions,
};